import { createRoot } from 'react-dom/client';
import PocketBase from 'pocketbase';
import App from './App.jsx';
import './main.css';

try {
  const pb = new PocketBase('https://pb.kongpodcast.com');
  window.pb = pb;
  console.log("PocketBase initialized globally:", pb.baseUrl);

  const container = document.getElementById('root');
  if (!container) {
    throw new Error("Root container element #root not found in DOM.");
  }

  const root = createRoot(container);
  root.render(<App />);
} catch (err) {
  console.error("Critical error during application initialization:", err);
}


